// request

/* global $ */

import $ from '@ali/tarzan-zepto';

export default class Model {
  constructor(options = {}) {
    const { env } = options;
    let beebotDomain;

    // 访客鉴权参数，所有接口都要带上
    this.xcookie = null;

    if (env === 'daily') {
      beebotDomain = '//ebee.daily.taobao.net';
    } else if (env === 'pre') {
      beebotDomain = '//pre-beebot.alibaba.com';
    } else {
      beebotDomain = '//beebot-sg.alibaba.com';
    }
    Object.assign(this, {
      env,
      beebotDomain,
    });
  }

  getToken(params) {
    return new Promise((resolve, reject) => {
      this.requestJSONP({
        url: `${this.beebotDomain}/lazada/guest`,
        data: params,
      })
        .then((data) => {
          resolve(data);
        }, (err) => {
          reject(err);
        });
    });
  }

  getConfig(params) {
    return new Promise((resolve, reject) => {
      this.requestJSONP({
        url: `${this.beebotDomain}/lazada/init`,
        data: params,
      })
        .then((data) => {
          resolve(data);
        }, (err) => {
          reject(err);
        });
    });
  }

  openair(data, timeout) {
    return this.requestJSONP({
      url: `${this.beebotDomain}/lazada/pivot`,
      data,
      timeout: timeout || 10000,
    });
  }

  lazadaLogin(params) {
    return new Promise((resolve, reject) => {
      this.requestJSONP({
        url: `${this.beebotDomain}/lazada/refresh`,
        data: params,
      })
        .then((data) => {
          resolve(data);
        }, (err) => {
          reject(err);
        });
    });
  }

  refreshUrl(params) {
    return `${this.beebotDomain}/lazada/refresh?_user_access_token=${params._user_access_token}&appId=${params.appId}`;
  }

   // 知识点评价
  robotRate(data) {
    return this.requestJSONP({
      url: `${this.beebotDomain}/lazada/feedback`,
      data,
    });
  }

  lazadaLogout() {
    return new Promise((resolve, reject) => {
      this.requestJSONP({
        url: `${this.beebotDomain}/logout`,
      })
        .then((data) => {
          resolve(data);
        }, (err) => {
          reject(err);
        });
    });
  }

  requestJSONP(options = {}) {
    const { data = {}, url, timeout = 10000, traditional = !!0 } = options;
    // 解决 WebX 框架获取queryString中文乱码问题
    Object.assign(data || {}, {
      _input_charset: 'utf-8',
    });

    // 三方的登陆鉴权
    if (this.xcookie) {
      Object.assign(data || {}, {
        'x-cookie': this.xcookie,
      });
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        data,
        timeout,
        traditional,
        type: 'get',
        dataType: 'jsonp',
        success: (response = {}) => {
          // var status = response.status !== undefined ? !!response.status
          // : ( response.success !== undefined ? !!response.success : !response.code);
          const { status, success, code } = response;
          let result = status;

          if (status === undefined) {
            result = success !== undefined ? !!success : !code;
          }

          return result ? resolve(response.data) : reject(response);
        },
        error: (xhr, errorType) => {
          reject(errorType);
        },
      });
    });
  }

  requestJSON(options = {}) {
    const { data = {}, url, timeout = 10000, traditional = !!0 } = options;
    // 解决 WebX 框架获取queryString中文乱码问题
    Object.assign(data || {}, {
      _input_charset: 'utf-8',
    });

    // 三方的登陆鉴权
    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        data,
        beforeSend(xhr) {
          try {
            xhr.withCredentials = true;
          } catch (e) {
            const nativeOpen = xhr.open;
            xhr.open = () => {
              const result = nativeOpen.apply(xhr, data);
              xhr.withCredentials = true;
              return result;
            };
          }
        },
        timeout,
        traditional,
        type: 'get',
        dataType: 'json',
        success: (response = {}) => {
          // var status = response.status !== undefined ? !!response.status
          // : ( response.success !== undefined ? !!response.success : !response.code);
          const { status, success, code } = response;
          let result = status;

          if (status === undefined) {
            result = success !== undefined ? !!success : !code;
          }
          return result ? resolve(response.data) : reject(response);
        },
        error: (xhr, errorType) => {
          reject(errorType);
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/bu/pc/model.js